import { render, staticRenderFns } from "./CouponsTable.vue?vue&type=template&id=9f74fc28&lang=pug&"
import script from "./CouponsTable.vue?vue&type=script&lang=js&"
export * from "./CouponsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VDataTable,VExpandTransition})
